export let addisonNotifNewItemsFmt = "BIyL_d";
export default {addisonNotifNewItemsFmt};